import { Container } from "../Container/Container";
import { FlexContainer } from "../Container/FlexContainer";
import { RadioGroup } from "../Form/RadioGroup";
import { Input } from "../Form/Input";
import { FileInput } from "../Form/FileInput";
import { Button } from "../Form/Item/Button";
import { SelectorHead } from "./SelectorHead";
import { toMap } from "../../../../HA";

export class MultiTextHead extends SelectorHead {

    private static dataURLtoFile(dataUrl, filename): File {
        const arr = dataUrl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {type: mime});
    }

    private static urlToFile(url: string, name: string): File | Promise<File> {
        if (url.indexOf("data", 0) === 0) {
            return MultiTextHead.dataURLtoFile(url, name);
        }

        return (fetch("/file/?redirect=" + url)
            .then((res) => {
                return res.arrayBuffer();
            })
            .then((buf) => {
                return new File([buf], name, {type: "image/png"});
            })
        );
    }

    protected initialize(data: any) {
        super.initialize(data);
        this.addClass("dsh");
        this.addClass("mtxteh");

        this.createRadioOption();
        this.createTxtAdder();
    }

    protected getTextField() {
        return this.get("tf");
    }

    protected getEditor() {
        return this.get("ed");
    }

    protected addText() {
        if (this.isType("img") || this.isType("file")) {
            const fileInput: FileInput = this.getTextField();
            this.getEditor().addImageFiles(fileInput.getFiles());
            fileInput.clear();
        } else if (this.isType("url")) {
            const input: Input = this.getTextField();
            const file = MultiTextHead.urlToFile(input.getText(), "image");
            if (file instanceof Promise) {
                file.then((f: File) => {
                    this.getEditor().addImageFile(f);
                    input.clear().focus();
                });
            } else {
                this.getEditor().addImageFile(file);
                input.clear().focus();
            }
        } else if (this.isType("json")) {
            const fileInput = this.getTextField();
            this.getEditor().addFiles(fileInput.getFiles());
            fileInput.clear();
        } else {
            const input: Input = this.getTextField();
            this.getEditor().addText(input.getText());
            input.clear().focus();
        }
    }

    private createRadioOption(): void {
        if (!this.isType("img/url")) {
            return null;
        }
        const radioGroup = new RadioGroup(toMap({
            radios: [
                {
                    l: {
                        attributes: [
                            {
                                n: "for",
                                v: "url",
                            },
                        ],
                        txt: "URL",
                    },
                    r: {
                        attributes: [
                            {
                                n: "id",
                                v: "url",
                            },
                            {
                                n: "value",
                                v: "url",
                            },
                            {
                                n: "checked",
                                v: "checked",
                            },
                            {
                                n: "name",
                                v: "file_url",
                            },
                        ],
                        rid: "url",
                    },
                },
                {
                    l: {
                        attributes: [
                            {
                                n: "for",
                                v: "file",
                            },
                        ],
                        txt: "Fichier",
                    },
                    r: {
                        attributes: [
                            {
                                n: "id",
                                v: "file",
                            },
                            {
                                n: "value",
                                v: "file",
                            },
                            {
                                n: "name",
                                v: "file_url",
                            },
                        ],
                        rid: "file",
                    },
                },
            ],
            onRadioChange: (r: any) => {
                this.onRadioChange(r);
            },
        }));
        this.appendChild(radioGroup);
    }

    private isType(type: string): boolean {
        return this.getType() === type;
    }

    private getType(): string {
        return this.get("t");
    }

    private getInputContainer(): Container {
        if (this.hasNot("icont")) {
            this.addToData("icont", new Container({className: "flex3"}));
        }
        return this.get("icont");
    }

    private replaceInputByType() {
        let tf: FileInput | Input = null;
        switch (this.getType()) {
            case "img":
            case "file":
            case "json":
                tf = new FileInput(toMap({
                    accept: this.get("accept"),
                    max: this.get("max"),
                    oc: () => {
                        this.addText();
                    },
                }));
                break;
            case "img/url":
                this.addToData("t", "url");
            case "url":
            default:
                tf = new Input();
                break;
        }
        tf.addClass("txtl");
        const c = this.getInputContainer();
        c.clear();
        c.appendChild(tf);
        this.addToData("tf", tf);

        if (this.get("tc") && tf instanceof FileInput) {
            tf.triggerClick();
        }
    }

    private createTxtAdder(): void {
        const c = new FlexContainer();
        const btn = new Button({
            click: () => {
                this.addText();
            },
            v: "ajouter",
        });
        c.appendChild(this.getInputContainer());
        c.appendChild(btn);
        this.replaceInputByType();
        this.appendChild(c);
    }

    private onRadioChange(e: any) {
        this.addToData("t", e.rid);
        this.replaceInputByType();
    }
}
